/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionTrainingFlagsModel } from '../../models/vision-training-flags-model';

export interface AdminMemberProfileMemberProfileIdVisionFlagsPut$Params {
  memberProfileId: string;
      body?: VisionTrainingFlagsModel
}

export function adminMemberProfileMemberProfileIdVisionFlagsPut(http: HttpClient, rootUrl: string, params: AdminMemberProfileMemberProfileIdVisionFlagsPut$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>> {
  const rb = new RequestBuilder(rootUrl, adminMemberProfileMemberProfileIdVisionFlagsPut.PATH, 'put');
  if (params) {
    rb.path('memberProfileId', params.memberProfileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>;
    })
  );
}

adminMemberProfileMemberProfileIdVisionFlagsPut.PATH = '/Admin/MemberProfile/{memberProfileId}/VisionFlags';
